import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src", "alt", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
                'lp-hero',
                'lp-hero--bg-image',
                $props.slide.CssClass,
                {'fg-image': $props.slide.ImageUrl && $props.slide.ImageUrl != ''}
             ]),
    style: _normalizeStyle({
                'background-image': $props.slide.BackgroundImageUrl != '' && `url(${$props.slide.BackgroundImageUrl})`,
                'background-position': `${$props.slide.BackgroundImageX}% ${$props.slide.BackgroundImageY}%`
             })
  }, [
    _createElementVNode("div", {
      class: "lp-hero__overlay",
      style: _normalizeStyle({'opacity': `${$props.slide.OverlayOpacity / 100}`})
    }, null, 4),
    _createElementVNode("div", {
      class: _normalizeClass(['lp-hero__content', $props.slide.ContentClass]),
      innerHTML: $props.slide.Content
    }, null, 10, _hoisted_1),
    ($props.slide.ImageUrl != '' && $props.slide.ImageUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['lp-hero__fg-image', $props.slide.FgImageClass])
        }, [
          _createElementVNode("img", {
            src: $props.slide.ImageUrl,
            alt: $props.slide.ImageAlt,
            title: $props.slide.ImageTitle
          }, null, 8, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true)
  ], 6))
}